<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <Header />
    <HeaderResponsive />
    <div class="container">
      <SecondHeader />
      <h2 class="title_section">Imágenes</h2>

      <div class="row">
        <div class="col-md-9 col-sm-12" style="padding-left: 0; margin-left: -10px">
          <carousel :per-page="2" paginationActiveColor="#3366CC" id="carousel_noticias">
            <slide v-for="(exp, index) in images" :key="index">
              <div class="row">
                <div class="col-md-10 col-sm-12">
                  <div class="card mb-3">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <img class="card-img"  alt="imagenes" style="opacity: 0.9: object-fit: cover"  :src="exp.image"/>
                      </div>
                      <div
                        class="col-md-12"
                        style="position:absolute; bottom: 0px; color: #444; font-weight: bolder"
                      >
                        <div class="card-body " style="background: rgba(0, 0, 0, 0.5); !important margin-bottom: 20px;">
                          <p
                            class="card-text"
                            style="text-align:right; position: relative; top: 50px;"
                          >
                            <a
                              @click="goToExp(exp.id)"
                              style="color: #fff;position: relative;top: -50px;"
                            ><h6  style="color:#fff; cursor: pointer">{{exp.name}}</h6></a>
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <div class="col-md-3 col-sm-12 filtros">
          <h4>Filtros</h4>
          <hr />
          <div class="form-group" v-for="(level, index) in levels" :key="index">
            <input
              type="radio"
              :value="level.id"
              @click="filterImages(level.id)"
              v-model="picked"
            />
              {{level.subLevel}}
          </div> 
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>



<script>
import Header from "./partials/Header";
import SecondHeader from "./partials/SecondHeader";
import HeaderResponsive from "./partials/HeaderResponsive";
import Footer from "./partials/Footer";
import { Carousel, Slide } from './carrousel'
import axios from "axios";
import _ from "lodash";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import config from '../../helpers/config';

export default {
  mounted() {
    this.getExperiences();
    this.getLevelAdaptation();
  },
  components: {
    Header,
    SecondHeader,
    HeaderResponsive,
    Footer,
    Carousel,
    Slide,
    Loading
  },
  data() {
    return {
      levelsFounds: [],
      allExperiences: [],
      experiences: [],
      images:[],
      threats: [],
      levels: [],
      level_adaptation: [],
      adaptationId: null,
      picked: null,
      isLoading: false,
      fullPage: true
    };
  },
  methods: {
    goToExp(id) {
      this.$router.push({ name: "DetalleExp", query: { user_id: id } });
    },
    getImages(data) {
      const images = data.map(item=>{
        return item.imagesLink.map(el=>{
          return {image:el,name:item.longName,id:item.id}
        })
      }).flat()
      //console.log(images)
      this.images = images;
    },
    async getThreat(threat) {
      const queryThreat = threat
        .map((item, index) => {
          return `&filter[where][or][${index}][id]=${item}`;
        })
        .join();
      try {
        const {data} = await axios.get(`${config.urlApi}/threatSubTypes?${queryThreat}`)
        console.log(data)
        //if  (data.length === 0) {
        //  this.images = []
        //}
        data.map((a) => {
          this.threats.push(a)
        })
      } catch (error) {
        console.error(error)
      }
    },
    async getLevel(level) {
      try {
        // const diff = _.difference(level, this.levelsFounds);
        // this.levelsFounds = [
        //   ...this.levelsFounds,
        //   ...diff
        // ]
        // console.log('level :', level);
        // console.log('diff :', diff);
        const {data} = await axios.get(`${config.urlApi}/adaptSubLevels/${level}`)
        console.log('--------------------------------------');
        console.log(data);
        console.log('--------------------------------------');

        if (data !== {}) {
          if (!this.levels.find(a => a && a.subLevel === data.subLevel)) {
            this.levels.push(data);
          }
        }
        //if  (data.length === 0) {
        //  this.images = []
        //}
        // this.levels.push(data);

      } catch (error) {
        console.log(error);
      }
    },
    async getThreatSubIds(threats) {
      console.log(threats)
      const that = this
      threats.map((threat) => {
        if (threat.length > 0) {
          that.getThreat(threat)
        }
      })
    },
    async getAdaptSubIds(levels) {
      console.log(levels);
      const that = this
      levels.map((level) => {
        if (level.length > 0) {
          that.getLevel(level)
        }
      })
    },
    getExperiences() {
      this.isLoading = true;
      //la idea es que me traiga lo mas reciente
      this.adaptationId = 2;
      const limit = "filter[limit]=5&"

      axios
        .get(
          `${config.urlApi}/experiences?${''}filter[where][expStatusId]=1`,
          {}
        )
        .then(({data}) => {
          this.getImages(data)
          this.allExperiences = data;
          this.experiences = data;
          this.getAdaptSubIds(data.map(a => a.adaptSubIds))
          this.isLoading = false;
        })
        .catch(function(error) {
          //console.log(error)
        });
    },
    getLevelAdaptation() {
      axios
        .get(`${config.urlApi}/adaptLevels`, {})
        .then(response => {

          this.level_adaptation = response.data;
        })
        .catch(function(error) {
          ////console.log(error)
        });
    },
    filterImages(id) {
      console.clear();
      //la idea es que me traiga lo mas reciente
      console.log(id);
      this.isLoading = true;
      this.adaptationId = id;
      // const filter = this.experiences.filter((exp, index) => {
      //   const found = exp.adaptSubIds.find(sub => sub === id)
      //   if (found) {
      //     console.log(found);
      //     return exp
      //   }
      // })
      const adaptId = this.adaptationId;
      const filter = this.allExperiences.filter((exp) => {
        const foundExp = exp.adaptIds.find((e) => e === adaptId);
        if (foundExp) {
          return exp;
        }
      });
      console.log('filter :>> ', filter);
      this.experiences = filter;
      this.getImages(filter)
      this.isLoading = false;
      // axios
      //   .get(
      //     `${config.urlApi}/experiences?filter[where][adaptationId]=${this.adaptationId}&filter[where][expStatusId]=1`,
      //     {}
      //   )
      //   .then(response => {
          
      //     this.experiences = response.data;
      //     this.isLoading = false;
      //   })
      //   .catch(function(error) {
      //     ////console.log(error)
      //   });
    }
  }
};
</script>


<style>
.VueCarousel-dot {
  background-color: transparent!important;
}
.title_section {
  color: #3366cc;
  font-weight: bolder;
  margin-bottom: 35px;
}
.text-objetivos {
  text-align: justify;
}
.container > .row:nth-child(2n),
.container > .row:nth-child(3n) {
  margin-bottom: 40px;
}
.exp_date {
  font-weight: bolder;
  line-height: 0.3;
}
.filtros {
  margin-top: -75px;
}
.card-body {
  background: #eee;
  color: #000;
  height: 80px;
}
.card-text {
  text-align: right;
  position: relative;
  top: 0px;
}
.card-title {
  margin-top: -50px;
}
@media (max-width: 768px) {
  .filtros {
    margin-top: 0px;
  }
}
</style>
